import { Outlet } from 'react-router-dom';
import './style.scss';

const Auth: React.FC = () => {
    return (
        <div className="bankcard-auth-root">
            <Outlet />
        </div>
    );
};

export default Auth;
